import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">See you soon</h1>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>

          <li>
            <a href="#skills" className="footer__link">
              Skills
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://m.me/aghartur"
            className="footer__social-link"
            target="_blank"
          >
            <i class="uil uil-facebook-messenger-alt"></i>
          </a>

          <a href="https://t.me/+33767638038" className="footer__social-link" target="_blank">
            <i class="uil uil-telegram-alt"></i>
          </a>

          <a href="https://wa.me/+33767638038" className="footer__social-link" target="_blank">
            <i class="uil uil-whatsapp"></i>
          </a>
        </div>

        <span className="footer__copy">&#169; Artur Aghasafyants. All rigths reserved</span>
      </div>
    </footer>
  );
};

export default Footer;
